import React from 'react'

interface StatsCardProps {
    icon: string
    backgroundColor: string
    title: string
    value: string | number
}

const StatsCard: React.FC<StatsCardProps> = ({ icon, backgroundColor, title, value }) => {
    return (
        <div style={{
            margin: '10px',
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            backgroundColor: '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'start',
            flex: 1
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    backgroundColor: backgroundColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginRight: '16px',
                    fontSize: '20px',
                    fontWeight: 'bold',
                    color: '#1a1a1a'
                }}>
                    <img src={icon} alt="" style={{ width: '27px', height: '27px' }} />
                </div>

                <div style={{ textAlign: 'left' }}>
                    <div style={{ fontSize: '16px', fontWeight: '400' }}>{title}</div>
                    <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {value || ''}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatsCard